const UPDATE_QUIZ_STARTED = 'UPDATE_QUIZ_STARTED'

const UPDATE_NUM_QUESTIONS = 'UPDATE_NUM_QUESTIONS'

const UPDATE_SELECTION = 'UPDATE_SELECTION'
const ADD_VIDEOS_WATCHED = 'ADD_VIDEOS_WATCHED'

const UPDATE_QUIZ_FINISHED = 'UPDATE_QUIZ_FINISHED'

const UPDATE_QUIZ_PASSED = 'UPDATE_QUIZ_PASSED'
const UPDATE_WRONG_ANSWERS_COUNT = 'UPDATE_WRONG_ANSWERS_COUNT'
const UPDATE_RETURN_URL = 'UPDATE_RETURN_URL'

const RETRY_QUIZ = 'RETRY_QUIZ'

const RESET = 'RESET'

export { 
    UPDATE_QUIZ_STARTED,
    UPDATE_NUM_QUESTIONS,
    UPDATE_SELECTION,
    ADD_VIDEOS_WATCHED,
    UPDATE_QUIZ_FINISHED,
    UPDATE_QUIZ_PASSED,
    UPDATE_WRONG_ANSWERS_COUNT,
    UPDATE_RETURN_URL,
    RETRY_QUIZ,
    RESET
}